import type { RateProviderUsageTranslations } from "../interfaces/rateProviderUsage";

export const rateProviderUsageTranslations: RateProviderUsageTranslations = {
  // Page
  page_title: "Rate provider usage",
  page_subtitle: "How many requests we spent with each exchange-rate provider, month by month",
  refresh_button: "Refresh",
  refresh_aria: "Refresh the usage counters",

  why_heading: "Why this counter and not the rate history",
  why_text:
    "Providers are tried in order and the first to answer wins, within the same request. If the primary fails it still spends its quota, but the rate that gets stored is the fallback's. This counts every request that leaves, answered or not.",

  month_label: "Month",

  error_load: "We could not load the usage",
  error_load_detail: "Try again. If it keeps failing, check that the service is reachable.",
  error_retry: "Try again",

  // Stat strip
  kpi_month_requests: "Requests this month",
  kpi_month_requests_meta: "Total for {{month}}, across every provider",
  kpi_month_failed: "Failed",
  kpi_month_failed_meta: "They spend quota just like the successful ones",
  kpi_primary: "Primary provider",
  kpi_primary_none: "None configured",
  kpi_primary_meta: "The first one asked",

  // Failover ladder
  ladder_heading: "Order of consultation",
  ladder_description:
    "Top to bottom, the order they are asked in. Each one shows what it cost and whether it answered.",
  ladder_role_primary: "Primary",
  ladder_role_fallback: "Fallback {{position}}",
  ladder_role_retired: "Out of the order",
  ladder_retired_hint: "Spent quota in this period but is no longer configured",
  ladder_never_answered: "Resolved no rate at all",
  ladder_bar_aria: "{{success}} resolved and {{failed}} failed",
  ladder_resolved: "{{value}} resolved",
  ladder_failed: "{{value}} failed",
  ladder_error_unknown: "no code",
  ladder_no_requests: "No requests in this period",
  ladder_requests_label: "requests",

  empty_title: "No requests recorded",
  empty_description: "No provider was asked this month. If you just deployed, the counter starts from there.",

  // Month over month
  monthly_heading: "By month",
  monthly_description: "To reconcile against the invoice and see whether usage is climbing.",
  monthly_column_month: "Month",
  monthly_column_total: "Total",
  monthly_failed_suffix: "({{value}} failed)",
  monthly_empty_cell: "—",
  monthly_empty_title: "No history yet",
  monthly_empty_description: "There are no months with recorded requests yet.",

  // Errors
  errors_heading: "Errors this month",
  errors_description: "Why they failed, to tell a bad deploy from an exhausted quota.",
  errors_none: "No provider failed this month.",
  errors_http_status: "· HTTP {{status}}",
  errors_detail_message: "Message",
  errors_detail_url: "Called URL",
  errors_detail_response: "Provider response",
  errors_occurrences: "{{value}} times",
  errors_last_at: "Last: {{at}}",
};
